// extracted by mini-css-extract-plugin
module.exports = {"pe_box":"pe_box-I0T9wtTK"};